var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F1D5D2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#FFF4F3",
    strokeOpacity: 0.4,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.125C19.1771 22.125 19.3255 22.0651 19.4453 21.9453C19.5651 21.8255 19.625 21.6771 19.625 21.5C19.625 21.3229 19.5651 21.1745 19.4453 21.0547C19.3255 20.9349 19.1771 20.875 19 20.875C18.8229 20.875 18.6745 20.9349 18.5547 21.0547C18.4349 21.1745 18.375 21.3229 18.375 21.5C18.375 21.6771 18.4349 21.8255 18.5547 21.9453C18.6745 22.0651 18.8229 22.125 19 22.125ZM18.375 19.625H19.625V15.875H18.375V19.625ZM19 25.25C18.1354 25.25 17.3229 25.0859 16.5625 24.7578C15.8021 24.4297 15.1406 23.9844 14.5781 23.4219C14.0156 22.8594 13.5703 22.1979 13.2422 21.4375C12.9141 20.6771 12.75 19.8646 12.75 19C12.75 18.1354 12.9141 17.3229 13.2422 16.5625C13.5703 15.8021 14.0156 15.1406 14.5781 14.5781C15.1406 14.0156 15.8021 13.5703 16.5625 13.2422C17.3229 12.9141 18.1354 12.75 19 12.75C19.8646 12.75 20.6771 12.9141 21.4375 13.2422C22.1979 13.5703 22.8594 14.0156 23.4219 14.5781C23.9844 15.1406 24.4297 15.8021 24.7578 16.5625C25.0859 17.3229 25.25 18.1354 25.25 19C25.25 19.8646 25.0859 20.6771 24.7578 21.4375C24.4297 22.1979 23.9844 22.8594 23.4219 23.4219C22.8594 23.9844 22.1979 24.4297 21.4375 24.7578C20.6771 25.0859 19.8646 25.25 19 25.25Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconContact);
export default __webpack_public_path__ + "static/media/error-icon-contact.7bb61524b6202d7eb2f4af8fedec27fc.svg";
export { ForwardRef as ReactComponent };